import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Breadcrumb,
  Table,
  Select,
  Form,
  Space,
  Tabs,
  Typography,
  Divider,
  Dropdown,
  Avatar,
  Tag,
  Modal,
  List,
  Checkbox,
  Tooltip,
  Empty,
} from "antd";
import {
  DoubleRightOutlined,
  DownOutlined,
  PhoneOutlined,
  MailOutlined,
  EditOutlined,
  FilePdfOutlined,
  BuildFilled,
  EnvironmentOutlined,
  BuildOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  GetWorkOrderByIdApi,
  UpdateWorkOrderApi,
  GetEstimatePdfApi,
  GetClientByIdApi,
  GetPartnerClientByIdApi,
  GetWorkOrderPdfApi,
} from "../ClientsApi";
import {
  getStatusAPI,
  getEmployeesAPI,
  getAddressProvincesAPI,
  getAddressCountriesAPI,
} from "CommonComponents/Lookup/LookupAPI";
import { FormattedMessage, useIntl } from "react-intl";
import AppointmentList from "../Appointments/AppointmentList";
import WorkOrderProducts from "../Components/WorkOrderProducts";
import InvoicesList from "features/Invoices/Components/InvoicesList";
import logoicon from "../../../logoicon.png";
import dayjs from "dayjs";
import InvoiceModal from "features/Invoices/Components/InvoiceModal";
import RecordPayment from "features/Invoices/Components/RecordPayment";
import { GetInvoicePaymentsByWorkOrderIdApi } from "features/Invoices/InvoicesAPI";

function WorkOrderDetails() {
  const { Column } = Table;
  const { Option } = Select;
  const { Title, Text } = Typography;
  const { id, workOrderId } = useParams();
  const [form] = Form.useForm();
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clientId, partnerId, projectId } = useParams();
  const companyId = localStorage.getItem("CompanyId");
  const statusData = useSelector((state) => state.lookup.statusList);
  const employeeData = useSelector((state) => state.lookup.employeesList);
  const workOrderData = useSelector((state) => state.clients.workOrderDetails);
  const client = useSelector((state) => state.clients.clientListById);
  const partner = useSelector((state) => state?.clients?.partnerClientById);
  const companyList = useSelector((state) => state.lookup.companyNames);
  const estimateStatusList = statusData?.filter(
    (status) => status.type === "EstimateStatus"
  );
  const [assignedTo, setAssignedTo] = useState(workOrderData?.assignedId);
  const [statusId, setStatusId] = useState(workOrderData?.statusId);
  const [isUpdated, setIsUpdated] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const selectedLanguage = localStorage.getItem("selectedlanguage");
  const [activeTab, setActiveTab] = useState("1");
  const [selected, setSelected] = useState("Accepted");
  const [disableEdit, setDisableEdit] = useState(false);
  const [isAdditionalItemsNotInvoiced, setIsAdditionalItemsNotInvoiced] =
    useState(false);
  const statusMap = {
    Rejected: { color: "#FC0027", label: "Rejected" }, // Red
    Closed: { color: "#1ECBE2", label: "Closed" }, // Blue
    Accepted: { color: "#5CB85C", label: "Accepted" }, // Green
    Pending: { color: "#ffaa00", label: "Pending" }, // Yellow
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isViewPaymentsModalOpen, setIsViewPaymentsModalOpen] = useState(false);
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  const workorderPayments = useSelector(
    (state) => state.invoices.workOrderPayments
  );
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleEdit = () => {
    navigate(
      partnerId && clientId
        ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/${workOrderData?.id}/editworkorder`
        : clientId
        ? `/${companyId}/${clientId}/client_details/${workOrderData?.id}/editworkorder`
        : `/${companyId}/${partnerId}/partner_client_details/${workOrderData?.id}/editworkorder`
    );
  };

  const handleViewPdf = async () => {
    try {
      await Promise.all([
        dispatch(GetWorkOrderPdfApi(workOrderData?.id)).then((response) => {
          if (response) {
            const base64 = response?.value?.pdfBase64;
            const fileName = `${workOrderData?.woNumber}.pdf`;
            const pdfDataUrl = `data:application/pdf;base64,${base64}`;
            const pdfWindow = window.open("", "_blank");
            if (pdfWindow) {
              pdfWindow.document.write(`
                <html>
                    <head><title>${fileName}</title></head>
                    <body style="margin:0">
                      <iframe width="100%" height="100%" src="${pdfDataUrl}" frameborder="0"></iframe>
                    </body>
                </html>
              `);
              pdfWindow.document.close();
            }
          }
        }),
      ]);
    } catch (e) {
      console.error("Error previewing PDF:", e);
    }
  };
  const items = Object.keys(statusMap).map((statusKey, index) => ({
    key: String(index),
    label: (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setSelected(statusKey);
        }}
      >
        {statusKey}
      </a>
    ),
  }));
  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const handleSelect = (checked, key) => {
    if (checked) {
      setSelectedRowKeys([...selectedRowKeys, key]);
    } else {
      setSelectedRowKeys(selectedRowKeys.filter((k) => k !== key));
    }
  };

  const columns = [
    {
      title: "Appointment No",
      dataIndex: "appNo",
      key: "appNo",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Completed" ? "green" : "orange"}>{status}</Tag>
      ),
    },
    {
      title: "Invoice",
      dataIndex: "invoiceStatus",
      key: "invoiceStatus",
      render: (status) => (
        <Tag color={status === "Generated" ? "blue" : "red"}>{status}</Tag>
      ),
    },
  ];
  const handleUpdate = () => {
    const updatedData = {
      workOrderId: workOrderId,
      assignedId: assignedTo,
      statusId: statusId,
    };

    dispatch(UpdateWorkOrderApi(updatedData)).then((success) => {
      if (success) {
        dispatch(GetWorkOrderByIdApi(workOrderId));
      }
      navigate(`/client_details/${id}`);
    });
  };

  const renderAddress = (addr) => {
    if (!addr) return "";
    const province = addressProvinces.find((p) => p.id === addr.provinceId);
    const country = addressCountries.find((c) => c.id === addr.countryId);

    const provinceName =
      selectedLanguage == "fr-FR"
        ? province?.provinceNameFr
        : province?.provinceNameEn;
    const countryName =
      selectedLanguage == "fr-FR"
        ? country?.countryNameFr
        : country?.countryNameEn;

    const parts = [
      addr?.address1,
      addr?.address2,
      addr?.city,
      provinceName,
      countryName,
      addr?.zip,
    ].filter(Boolean);

    const line1 = [addr?.address1, addr?.address2].filter(Boolean).join(", ");
    const line2 = [addr?.city, provinceName, countryName, addr?.zip]
      .filter(Boolean)
      .join(", ");

    return (
      <>
        {line1}
        <br className="sm-d-none" />
        {line2}
      </>
    );
  };

  const handlePrint = async (estimateid) => {
    try {
      await Promise.all([
        dispatch(GetEstimatePdfApi(estimateid)).then((response) => {
          if (response) {
            const pdfDataUrl = `data:application/pdf;base64,${response?.pdfBase64}`;
            const fileName = response?.fileName;
            const pdfWindow = window.open("", "_blank");
            pdfWindow.document.write(
              `<iframe src="${pdfDataUrl}" frameborder="0" style="border:0; width:100%; height:100%;" allowfullscreen></iframe>`
            );
            pdfWindow.document.title = fileName;
          }
        }),
      ]);
    } catch (e) {
      console.error("Error previewing PDF:", e);
    }
  };
  const handleGenerate = () => {
    navigate(
      partnerId && clientId
        ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/${projectId}/projects/wo_details/${workOrderId}/generateinvoice`
        : clientId
        ? `/${companyId}/${clientId}/client_details/wo_details/${workOrderId}/generateinvoice`
        : `/${companyId}/${partnerId}/partner_client_details/wo_details/${workOrderId}/generateinvoice`
    );
  };
  const columns1 = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },

    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount, record) => {
        let color = "black"; // default
        if (record.type === "Refund") color = "red";
        else if (record.type === "Payment Received") color = "green";
        else if (record.type === "Deposit") color = "blue";

        return <span style={{ color }}>{amount}</span>;
      },
    },
  ];

  const columns2 = [
    {
      title: <FormattedMessage id="ClientDetails.Date" />,
      dataIndex: "date",
      key: "date",
    },
    {
      title: <FormattedMessage id="Invoice.InvoiceNo" />,
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: <FormattedMessage id="Lookup.Type" />,
      dataIndex: "type",
      key: "type",
    },
    {
      title: <FormattedMessage id="AddProject.Reference" />,
      dataIndex: "reference",
      key: "reference",
      render: (text) => <p>{text}</p>,
    },
    {
      title: <FormattedMessage id="ClientDetails.Amount" />,
      dataIndex: "amount",
      key: "amount",
      render: (amount, record) => {
        let color = "black"; // default
        if (record.type === "Refund") color = "red";
        else if (record.type === "Payment Received") color = "green";
        else if (record.type === "Deposit") color = "blue";

        return <span style={{ color }}>{amount}</span>;
      },
    },
    // {
    //   title: "Discount",
    //   dataIndex: "discount",
    //   key: "discount",
    // },
    // {
    //   title: "Refund",
    //   dataIndex: "refund",
    //   key: "refund",
    //   render: (refund) => <span style={{ color: "red" }}>{refund}</span>,
    // },
    {
      title: <FormattedMessage id="AddEstimate.Notes" />,
      dataIndex: "refundnotes",
      key: "refundnotes",
    },
  ];

  // Payment type mapping
  const paymentTypeMap = {
    1: "Payment Received",
    2: "Refund",
    3: "Deposit",
  };
  const paymentsArray = workorderPayments?.payments || [];
  const data1 = paymentsArray?.map((payment, index) => ({
    key: payment.id || index,
    date: new Date(payment.paymentDate).toISOString().split("T")[0],
    invoiceNumber: payment.invoiceNumber || "-",
    type: paymentTypeMap[payment.paymentTypeId] || "Unknown",
    amount: `$${payment.amountReceived.toFixed(2)}`,
  }));
  const InvoicePaymentsTotal = workorderPayments?.total || 0;
  const invoiceDiscount = workorderPayments?.totalDiscountAmount || 0;
  const grandTotal = InvoicePaymentsTotal + invoiceDiscount;
  const workOrderGrandTotal = workorderPayments?.workOrderGrandTotal || 0;
  const outstandingAmount =
    workorderPayments?.workOrderGrandTotal +
    workorderPayments?.additionalItemsAmount -
    grandTotal;
  const additionalItemsAmount = workorderPayments?.additionalItemsAmount || 0;
  useEffect(() => {
    dispatch(GetWorkOrderByIdApi(workOrderId));
    dispatch(getAddressProvincesAPI());
    dispatch(getAddressCountriesAPI());
  }, [dispatch]);

  useEffect(() => {
    if (partnerId) {
      dispatch(GetPartnerClientByIdApi(partnerId));
    } else if (clientId) {
      dispatch(GetClientByIdApi(clientId));
    }
  }, [clientId]);

  useEffect(() => {
    dispatch(getStatusAPI());
    dispatch(getEmployeesAPI());
    dispatch(GetInvoicePaymentsByWorkOrderIdApi(workOrderId));
  }, [dispatch, workOrderId]);

  useEffect(() => {
    setAssignedTo(workOrderData?.assignedId);
    setStatusId(workOrderData?.statusId);
    if (workOrderData?.estimateReference) {
      setDisableEdit(true);
    }
  }, [workOrderData]);

  useEffect(() => {
    if (
      assignedTo !== workOrderData?.assignedId ||
      statusId !== workOrderData?.statusId
    ) {
      setIsUpdated(true);
    } else {
      setIsUpdated(false);
    }
  }, [assignedTo, statusId, workOrderData]);
  useEffect(() => {
    if (workOrderData) {
      const assignedValue = workOrderData?.assignedId
        ? workOrderData?.assignedId
        : undefined;
      const additionalItemsNotInvoiced = workOrderData?.workOrderItems?.some(
        (i) => i.isActive && i.isAdditionalItem && !i.isInvoiced
      );

      setAssignedTo(assignedValue);
      setStatusId(workOrderData?.statusId || null);
      setIsAdditionalItemsNotInvoiced(additionalItemsNotInvoiced);

      form.setFieldsValue({
        assignedTo: workOrderData?.assignedTo,
        statusId: workOrderData?.statusId,
      });
    }
  }, [workOrderData, form]);

  return (
    <div className="medispamain" style={{ position: "relative" }}>
      <div className="main-area">
        <div className="title-part">
          <Row align="middle" justify="space-between" gutter={[16, 16]}>
            <Col xs={24} md={16} lg={12}>
              <h4>
                {<FormattedMessage id="WorkOrderDetails.WorkOrderDetails" />}
              </h4>
              <p className="mt-5px">
                <FormattedMessage id="WorkOrderDetails.Manageworkordersandassociatedappointmentsinoneplace." />
              </p>
            </Col>

            <Col
              xs={24}
              md={8}
              lg={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                textAlign: "right",
              }}
            >
              <Breadcrumb
                separator={<DoubleRightOutlined />}
                items={[
                  {
                    title: (
                      <FormattedMessage
                        id={
                          partnerId
                            ? "PartnerCLient.Partners"
                            : "ClientDetails.Clients"
                        }
                      />
                    ),
                    href: partnerId
                      ? `/${companyId}/partner`
                      : `/${companyId}/clients`,
                  },
                  {
                    title: (
                      <FormattedMessage
                        id={
                          partnerId
                            ? "PartnerClient.PartnerClientDetails"
                            : "ClientDetails.ClientDetails"
                        }
                      />
                    ),
                    href: clientId
                      ? `/${companyId}/${clientId}/client_details`
                      : `/${companyId}/${partnerId}/partner_client_details`,
                  },
                  partnerId &&
                    clientId && {
                      title: (
                        <FormattedMessage id="ClientDetails.ClientDetails" />
                      ),
                      href: `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details`,
                    },
                  {
                    title: (
                      <FormattedMessage id="WorkOrderDetails.WorkOrderDetails" />
                    ),
                  },
                ].filter(Boolean)} // ✅ filters out falsy items like `false`
              />
            </Col>
          </Row>
        </div>
        <Card className="clientview-new">
          <Row
            align="middle"
            justify="space-between"
            gutter={[16, 16]} // Adds spacing between rows/cols
          >
            {/* ✅ Left Side - Client Info */}
            <Col xs={24} sm={8}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  alignItems: "flex-start",
                  gap: 12,
                }}
              >
                {/* Avatar */}
                <div style={{ width: 48 }}>
                  <Avatar
                    style={{
                      backgroundColor: "#3a5892",
                      verticalAlign: "middle",
                      width: 48,
                      height: 48,
                      fontSize: 18,
                    }}
                  >
                    {workOrderData?.clientId
                      ? workOrderData?.clientName?.charAt(0).toUpperCase()
                      : workOrderData?.partnerName?.charAt(0).toUpperCase()}
                  </Avatar>
                </div>

                {/* Client Info */}
                <div style={{ flex: 1 }}>
                  <h4
                    className="word-break"
                    style={{ fontWeight: "bold", marginBottom: 4 }}
                  >
                    {workOrderData?.clientId
                      ? workOrderData?.clientName
                      : workOrderData?.partnerName}
                  </h4>
                  <Space direction="vertical" size={0}>
                    <p style={{ margin: 0 }}>
                      <PhoneOutlined style={{ marginRight: 8 }} />
                      {partner ? partner?.countryCode : client?.countryCode}
                      &nbsp;
                      {partner
                        ? partner?.phone
                        : client?.phone?.replace(
                            /(\d{3})(\d{3})(\d{4})/,
                            "$1-$2-$3"
                          )}
                    </p>
                    <p style={{ margin: 0 }}>
                      <MailOutlined style={{ marginRight: 8 }} />
                      {partner ? partner?.email : client?.email}
                    </p>
                  </Space>
                </div>
              </div>
            </Col>

            {/* ✅ Right Side - Buttons */}
            <Col xs={24} sm={16}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
                className="button-group-responsive"
              >
                <Tooltip
                  title={
                    disableEdit ? (
                      <FormattedMessage id="WorkOrder.WorkOrderCannotBeEdited" />
                    ) : null
                  }
                >
                  <Button
                    variant="outline"
                    onClick={handleEdit}
                    disabled={disableEdit}
                  >
                    <EditOutlined />
                    <FormattedMessage id="WorkOrder.EditWorkOrder" />
                  </Button>
                </Tooltip>

                <Button
                  color="primary"
                  variant="outlined"
                  onClick={handleViewPdf}
                >
                  <FilePdfOutlined />
                  <FormattedMessage id="WorkOrderDetails.PrintWO" />
                </Button>

                <Button
                  color="primary"
                  variant="outlined"
                  onClick={() => setIsViewPaymentsModalOpen(true)}
                >
                  <FilePdfOutlined />
                  <FormattedMessage id="WorkOrderDetails.ViewPayments" />
                </Button>

                <Button
                  color="primary"
                  variant="outlined"
                  onClick={() => setIsPaymentModalOpen(true)}
                  disabled={workOrderData?.depositReceived}
                >
                  <FilePdfOutlined />
                  <FormattedMessage id="WorkOrderDetails.RecordDeposit" />
                </Button>

                {isAdditionalItemsNotInvoiced ? (
                  <InvoiceModal />
                ) : (
                  <Button type="primary" onClick={handleGenerate}>
                    <FilePdfOutlined />
                    <FormattedMessage id="WorkOrderDetails.GenerateInvoice" />
                  </Button>
                )}
              </div>
            </Col>
          </Row>

          <Modal
            title={<FormattedMessage id="WorkOrderDetails.Payments" />}
            open={isViewPaymentsModalOpen}
            onCancel={() => setIsViewPaymentsModalOpen(false)}
            footer={null}
            width={700}
          >
            <div style={{ textAlign: "left", fontWeight: "bold" }}>
              <FormattedMessage id="WorkOrderDetails.WOAmount" />: $
              {workOrderGrandTotal.toFixed(2)}
            </div>
            {additionalItemsAmount > 0 && (
              <div style={{ textAlign: "center", fontWeight: "bold" }}>
                <FormattedMessage id="WorkOrderDetails.AdditionalItemsAmount" />
                : ${additionalItemsAmount.toFixed(2)}
              </div>
            )}
            <div style={{ textAlign: "right", fontWeight: "bold" }}>
              <FormattedMessage id="WorkOrderDetails.Outstanding" />: $
              {outstandingAmount.toFixed(2)}
            </div>
            <Table
              columns={columns2}
              dataSource={paymentsArray?.map((payment, index) => ({
                key: payment.id || index,
                date: new Date(payment.paymentDate).toISOString().split("T")[0],
                invoiceNumber: payment.invoiceNumber,
                type: paymentTypeMap[payment.paymentTypeId] || "Unknown",
                reference: payment.referenceNumber || "-",
                amount: `$${payment.amountReceived.toFixed(2)}`,
                refundnotes: payment.refundNotes || "",
              }))}
              pagination={false}
              bordered
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={intl.formatMessage({
                      id: "NoData",
                    })}
                  />
                ),
              }}
            />
            <Divider />
            <div style={{ textAlign: "right", fontWeight: "bold" }}>
              <FormattedMessage id="WorkOrderDetails.Total" />: $
              {InvoicePaymentsTotal.toFixed(2)}
            </div>
            <div style={{ textAlign: "right", fontWeight: "bold" }}>
              <FormattedMessage id="Quote.Discount" />: $
              {invoiceDiscount.toFixed(2)}
            </div>
            <div style={{ textAlign: "right", fontWeight: "bold" }}>
              <FormattedMessage id="AddEstimate.GrandTotal" />: $
              {grandTotal.toFixed(2)}
            </div>

            <div
              style={{
                marginTop: 16,
                textAlign: "center",
                color: "#faad14",
                fontSize: 13,
              }}
            >
              <FormattedMessage id="RecordPayment.DepositNote" />
            </div>
          </Modal>
        </Card>

        <div className="mt-10">
          <Card className="clientview-new">
            <Row gutter={[16, 16]} className="wordorder-top">
              <Col xs={12} sm={12} md={5}>
                <Text strong>
                  <FormattedMessage id="ClientDetails.QuatationNo" />
                </Text>
                <br className="sm-d-none" />
                <Text>
                  {workOrderData?.estimateReference ? (
                    `#${workOrderData?.estimateReference}`
                  ) : (
                    <FormattedMessage id="WorkOrder.NoQuote" />
                  )}
                </Text>
              </Col>

              <Col xs={12} sm={12} md={5}>
                <Text strong>
                  <FormattedMessage id="WorkOrderDetails.WorkOrderNo" />
                </Text>
                <br className="sm-d-none" />
                <Text>
                  #{workOrderData?.woNumber}{" "}
                  {workOrderData?.isPm ? "(PM)" : null}
                </Text>
              </Col>

              <Col xs={12} sm={12} md={5}>
                <Text strong>
                  <FormattedMessage id="WorkOrder.StartDate" />
                </Text>
                <br className="sm-d-none" />
                <Text>
                  {dayjs(workOrderData?.contractStartDate).format("YYYY-MM-DD")}
                </Text>
              </Col>

              <Col xs={12} sm={12} md={5}>
                <Text strong>
                  <FormattedMessage id="Common.Status" />
                </Text>
                <br className="sm-d-none" />
                <Dropdown menu={{ items }} trigger={["click"]}>
                  <Button
                    onClick={(e) => e.preventDefault()}
                    size="small"
                    style={{
                      backgroundColor: statusMap[selected]?.color,
                      color: "#fff",
                      border: "none",
                    }}
                  >
                    {statusMap[selected]?.label} <DownOutlined />
                  </Button>
                </Dropdown>
              </Col>

              <Col xs={12} sm={12} md={4}>
                <Text strong>
                  <FormattedMessage id="WorkOrderDetails.TotalAmount" />
                </Text>
                <br className="sm-d-none" />
                <Text>${(workOrderData?.grandTotal ?? 0)?.toFixed(2)}</Text>
              </Col>
            </Row>

            <Divider className="mt-10" />

            <Row gutter={[16, 16]} justify="space-between">
              <Col xs={24} sm={8} lg={14}>
                <Text strong className="upper-case">
                  {<FormattedMessage id="WorkOrderDetails.From" />}
                </Text>
                <p className="mt-5px">
                  <b>{workOrderData?.companyName}</b>
                  <br></br>
                  <p>{renderAddress(workOrderData?.fromAddress)}</p>
                </p>
              </Col>
              <Col xs={24} sm={8} lg={5}>
                <Text strong className="upper-case">
                  {<FormattedMessage id="WorkOrderDetails.BillTo" />}
                </Text>

                <p className="mt-5px">
                  <b>
                    {workOrderData?.partnerName
                      ? workOrderData?.partnerName
                      : workOrderData?.clientName}
                  </b>
                  <br></br>
                  <p>{renderAddress(workOrderData?.billingAddress)}</p>
                </p>
              </Col>
              <Col xs={24} sm={8} lg={5}>
                <Text strong className="upper-case">
                  <FormattedMessage id="WorkOrderDetails.DeliverTo" />
                </Text>

                <p className="mt-5px">
                  <b>{workOrderData?.clientName}</b>
                  <br></br>
                  {/* {[
                    workOrderData?.companyAddress?.address1,
                    workOrderData?.companyAddress?.address2,
                    workOrderData?.companyAddress?.city &&
                      `${workOrderData.companyAddress.city}, ${workOrderData.companyAddress.state} - ${workOrderData.companyAddress.zip}`,
                    workOrderData?.companyAddress?.country,
                  ]
                    .filter(Boolean)
                    .map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                       <br className="sm-d-none" />
                      </React.Fragment>
                    ))} */}
                  <p>{renderAddress(workOrderData?.companyAddress)}</p>
                </p>
              </Col>
            </Row>
          </Card>
          <Tabs
            defaultActiveKey="1"
            centered
            onChange={handleTabChange}
            className="mt-10"
          >
            <Tabs.Item tab="Appointments" key="1">
              <AppointmentList />
            </Tabs.Item>
            <Tabs.Item tab="Products/Services" key="2">
              <WorkOrderProducts />
            </Tabs.Item>
            <Tabs.Item tab={<FormattedMessage id="Invoice.Heading" />} key="3">
              <InvoicesList
                workOrderId={workOrderId}
                CreateInvoiceVisible={false}
              />
            </Tabs.Item>
            <Tabs.Item tab="Others" key="4">
              <Card>
                <Row className="mt-5px">
                  <Col span={24}>
                    <h5 className="text-dark">
                      {<FormattedMessage id="WorkOrderDetails.Notes" />}:
                    </h5>
                    <p>
                      {workOrderData?.notes || "No additional notes available."}
                    </p>
                  </Col>
                </Row>
                <Row className="mt-20">
                  <Col span={24}>
                    <h5 className="text-dark">
                      {
                        <FormattedMessage id="WorkOrderDetails.TermsAndConditions" />
                      }
                      :
                    </h5>
                    <p
                      dangerouslySetInnerHTML={{
                        __html:
                          workOrderData?.termsAndConditions ||
                          "No additional terms and conditions available.",
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-20">
                  <Col span={24}>
                    <h5 className="text-dark">Attachments:</h5>
                  </Col>
                </Row>
              </Card>
            </Tabs.Item>
          </Tabs>
        </div>
        {isPaymentModalOpen && (
          <RecordPayment
            isDeposit={true}
            open={isPaymentModalOpen}
            close={() => setIsPaymentModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
}

export default WorkOrderDetails;
